import { ServiceHandler } from '../../utils';
import type {
  CoverageOption,
  CoverageOptionDto,
  QuoteOptionsRequest,
  QuoteOptionsResult,
  ShallowSubmissionCoverageDto,
  SubmissionCoverageDto,
} from './submission-coverages.types';

const BASE_URL = '/api/account/v1/submission/:submissionId/coverage';

export const getSubmissionCoverage = ServiceHandler<
  unknown,
  SubmissionCoverageDto
>({
  url: BASE_URL,
  method: 'GET',
});

export const updateSubmissionCoverage = ServiceHandler<
  Partial<ShallowSubmissionCoverageDto>,
  SubmissionCoverageDto
>({
  url: BASE_URL,
  method: 'PUT',
});

export const upsertCoverageOption = ServiceHandler<
  CoverageOptionDto,
  CoverageOption
>({
  url: `${BASE_URL}/options`,
  method: 'POST',
});

export const deleteCoverageOption = ServiceHandler({
  url: `${BASE_URL}/options/:optionId`,
  method: 'DELETE',
});

export const getCoverageOption = ServiceHandler<unknown, CoverageOptionDto>({
  url: `${BASE_URL}/options/:optionId`,
  method: 'GET',
});

export const quoteCoverageOptions = ServiceHandler<
  QuoteOptionsRequest,
  QuoteOptionsResult[]
>({
  url: `${BASE_URL}/options/quote`,
  method: 'POST',
});
